var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.467 16.4993L25.246 15.4588C24.5282 14.8471 23.4718 14.8471 22.754 15.4588L21.5328 16.4993C21.2252 16.7615 20.8428 16.9198 20.4399 16.952L18.842 17.0794C17.9019 17.1544 17.1542 17.901 17.0792 18.8411L16.9512 20.4402C16.9191 20.8431 16.7618 21.2254 16.4996 21.533L15.4586 22.7542C14.8469 23.472 14.8472 24.5276 15.4589 25.2454L16.499 26.4666C16.7611 26.7742 16.92 27.1565 16.9521 27.5594L17.08 29.1585C17.1551 30.0986 17.9006 30.8452 18.8408 30.9202L20.4404 31.0477C20.8433 31.0798 21.2256 31.2382 21.5332 31.5003L22.7539 32.5409C23.4717 33.1526 24.5282 33.1525 25.246 32.5407L26.4667 31.5002C26.7744 31.2381 27.1567 31.08 27.5595 31.0478L29.1591 30.9202C30.0993 30.8452 30.8449 30.0984 30.9199 29.1583L31.0478 27.5593C31.08 27.1564 31.2388 26.7738 31.5009 26.4662L32.541 25.2454C33.1527 24.5275 33.1526 23.4716 32.5409 22.7538L31.5008 21.5332C31.2387 21.2256 31.0797 20.8431 31.0475 20.4402L30.9204 18.8409C30.8453 17.9008 30.0986 17.1545 29.1585 17.0795L27.5594 16.9521C27.1566 16.9199 26.7746 16.7614 26.467 16.4993Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.7b3808ec3316d0a5c4e1f735a2528b0d.svg";
export { ForwardRef as ReactComponent };